export const OBJECTSDATA_URL = `${process.env.REACT_APP_API_URL}/objectsData`;
export const FMSD_URL = `${process.env.REACT_APP_URL}/module/FMSD/api/warehouse`;
export const fmsDotUrl = `${process.env.REACT_APP_URL}/module/FMSD/api`;
export const TPMS_URL = `${process.env.REACT_APP_URL}/module/FMSD/api/tpms`;